@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import xyz.malefic.kanman.client.components.layouts.NavBarLayout as _xyz_malefic_kanman_client_components_layouts_NavBarLayout
import xyz.malefic.kanman.client.pages.About as _xyz_malefic_kanman_client_pages_About
import xyz.malefic.kanman.client.pages.Index as _xyz_malefic_kanman_client_pages_Index
import xyz.malefic.kanman.client.pages.Login as _xyz_malefic_kanman_client_pages_Login
import xyz.malefic.kanman.client.pages.Logout as _xyz_malefic_kanman_client_pages_Logout
import xyz.malefic.kanman.client.pages.boards.Public as _xyz_malefic_kanman_client_pages_boards_Public
import xyz.malefic.kanman.client.pages.boards.drive.Board as _xyz_malefic_kanman_client_pages_boards_drive_Board
import xyz.malefic.kanman.client.pages.boards.drive.Drive as _xyz_malefic_kanman_client_pages_boards_drive_Drive

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.http.logOnError = true

    AppGlobals.initialize(mapOf("title" to "KanMan"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx, pageMethod -> 
            _xyz_malefic_kanman_client_components_layouts_NavBarLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_Index()
        }
        ctx.router.register(
            "/about",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_About()
        }
        ctx.router.register(
            "/boards/drive/",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_boards_drive_Drive(pageCtx)
        }
        ctx.router.register(
            "/boards/drive/{id}",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_boards_drive_Board(pageCtx)
        }
        ctx.router.register(
            "/boards/public",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_boards_Public(pageCtx)
        }
        ctx.router.register(
            "/login",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_Login(pageCtx)
        }
        ctx.router.register(
            "/logout",
            layoutId = "xyz.malefic.kanman.client.components.layouts.NavBarLayout",
        ) { pageCtx -> 
            _xyz_malefic_kanman_client_pages_Logout(pageCtx)
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerKeyframes("spin", xyz.malefic.kanman.client.components.SpinKeyframes)
        xyz.malefic.kanman.client.styles.initColor(ctx)
        xyz.malefic.kanman.client.styles.initStyles(ctx)
        xyz.malefic.kanman.client.styles.initTypography(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        xyz.malefic.kanman.client.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
